module.exports = __webpack_public_path__ + "static/media/A1-9-Neonyus-cod91.55ad900c.png";